import { useMutation } from 'react-query';
import axios from 'axios';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const useRevokeMerchantInfo = () => {
  const { token } = useContext(AuthContext);

  return useMutation(async (merchantId) => {
    const response = await axios.put(
      `${process.env.REACT_APP_SERVER_URL}/users/merchant/revoke/${merchantId}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  });
};

export default useRevokeMerchantInfo;
